import React from 'react'
import Topheader from '../../Home/topHeader/Topheader'
import Middlebar from '../../Home/middleBar/Middlebar'
import NavMenu from '../../Home/navigationBar/NavMenu'
// import Navbar from '../../Home/navigationBar/Navbar'
import Footer from '../../Home/footer/Footer'
// import AccordionCard from './AccordionCard'
// import Accordian from '../accordion/Accordian'
import { Link } from "react-router-dom";
import AccordionCard from './AccordionCard'

export default function BBA4Years() {
  return (
    <>
    <Topheader/>
    <Middlebar/>
    <NavMenu/>
    {/* <Navbar/> */}
      <div className="  bg-gray-200  ">
        <div className="banner">
            <img src='/BBA4YEARS.png' 
             alt='BBA 4 YEARS'
             className='w-full sm:w-[100%] md:w-[100%] lg:w-[100%] '/>
        </div>
        <div className="content bg-gray-200 2xl:w-[80%] xl:w-[90%] lg:w-[100%] md:w-[100%] sm:w-[100%] xs:w-[200%]  justify-center justify-items-center mx-auto ">
          <div className="mx-28 2xl:w-[83%] xs:text-base">
               <h1 className='text-5xl font-bold mt-20 font-poppins text-red-800'>Course Detail</h1>

               <p className=" text-justify mt-4 mb-5 ">
               The Bachelor of Business Administration (BBA) is a four years degree program that offers the fundamental concepts 
               required in today's business world. The program is tailored around the basic areas of business, management, economics, 
               marketing, accounting, MIS and finance. It trains students to develop an understanding of the global business environment. 
               A distinctive feature of the BBA program is that it incorporates within the curriculum major an emphasis on the development 
               of students' fundamental learning skills, for example: reasoning, quantitative abilities, communication and computing skills 
               which they will need for responsible leadership roles in their careers.
               </p>

               <p className=" text-justify mt-2 mb-5 ">
               BBA is a regular 4 years Degree Program (8 Semesters) and comprises of 45 courses and a research project 
               (3 credit hours). The minimum program duration will be 4 years; the maximum duration will be 6 years. Degree
                requirement for BBA Program is minimum 2.0 CGPA.
               </p>
               
               {/* <h3 className=" font-semibold text-sm">BBA Students learn to</h3>
               <ul className='list-disc mx-7 mt-2 mb-3 text-sm'>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
               </ul>

               <h3 className=" font-semibold text-base mt-5 ">Learning Outcomes for BBA Students include:</h3>
               <ol className='list-decimal mx-7 mt-2 text-sm mb-5'>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
               </ol> */}

               <h1 className="text-2xl font-bold  font-poppins text-red-800">Eligibility Criteria</h1>
               <p className='mt-2'>
                <li className='m-1'>Minimum 16 years of education from HEC recognized DAI/University</li>
                <li className='m-1'>Applicant must clear Admission/aptitude Test of EIMS or (GAT/HAT)</li>
                <li className='m-1'>Interview conducted by the institute</li>
                <li className='m-1'>Required credentials as per HEC policy</li>
                </p> 
          </div>
          <div className='mt-10 mb-10 '>
            {/* <Accordian/> */}
            <AccordionCard />      
            </div>
        <div >
       <Link to="/ApplyNow"><button className="mx-28 w-80 h-14 rounded-md text-white bg-maroon  font-bold text-3xl">APPLYNOW</button></Link> 
      </div>
        </div>
        <div className=' pb-20'>

        </div>
      </div>
    <Footer/>  
    </>
  )
}
